import types from './actionTypes';
import { leadFilters } from '../../config/filters';
import { addOrReplaceObjectInArray } from '../../helpers/reducerHelper';

const initialState = {
  loading: false,
  leads: [],
  startDate: null,
  endDate: null,
  filters: { ...leadFilters },
  error: '',
  logs: [],
  // The conversations of the leads above, keyed by lead id. Never merged into
  // the rows: updateLeadSaga writes on Firestore whatever a row carries.
  aiByLead: {},
  aiLoading: false,
  aiError: '',
};

const allLeads = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_LEAD_STATE:
      return initialState;
    case types.FETCH_LEADS.REQUEST:
    case types.FETCH_SINGLE_LEAD.REQUEST:
    case types.CREATE_LEAD.REQUEST:
    case types.IMPORT_LEADS.REQUEST:
    case types.ADD_PUSH_TOKEN_LEAD.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case types.DUPLICATE_LEADS.REQUEST:
    case types.CLOSE_EXCESS_LEADS.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
        logs: [],
      };
    case types.FETCH_LEADS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        leads: action.leads,
        startDate: action.startDate,
        endDate: action.endDate,
        filters: { ...action.filters },
        // New rows, so neither the map read for the previous range nor its
        // outcome is about them. The error goes too: a range where no lead
        // has been through the agent makes the saga skip its request, and
        // the previous range's failure would stay on screen under the new
        // rows. The busy flag goes for the read that was just cancelled.
        aiByLead: {},
        aiLoading: false,
        aiError: '',
      };
    case types.FETCH_SINGLE_LEAD.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        leads: addOrReplaceObjectInArray(state.leads, action.lead),
      };
    case types.IMPORT_LEADS.SUCCESS:
    case types.CREATE_LEAD.SUCCESS:
    case types.ADD_PUSH_TOKEN_LEAD.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
      };
    case types.DUPLICATE_LEADS.SUCCESS:
    case types.CLOSE_EXCESS_LEADS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        logs: action.logs,
      };
    case types.FETCH_LEADS.FAILURE:
    case types.FETCH_SINGLE_LEAD.FAILURE:
    case types.CREATE_LEAD.FAILURE:
    case types.IMPORT_LEADS.FAILURE:
    case types.UPDATE_LEAD.FAILURE:
    case types.DUPLICATE_LEADS.FAILURE:
    case types.CLOSE_EXCESS_LEADS.FAILURE:
    case types.ADD_PUSH_TOKEN_LEAD.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      };
    case types.FETCH_LEADS_AI_CONVERSATIONS.REQUEST:
      return {
        ...state,
        aiLoading: true,
        aiError: '',
      };
    case types.FETCH_LEADS_AI_CONVERSATIONS.SUCCESS:
      return {
        ...state,
        aiLoading: false,
        aiByLead: action.aiByLead,
      };
    case types.FETCH_LEADS_AI_CONVERSATIONS.FAILURE:
      // Its own field: the rows are there, only the agent columns are not.
      return {
        ...state,
        aiLoading: false,
        aiError: action.error.message,
      };
    default:
      return state;
  }
};

export default allLeads;
